import { PropsWithChildren } from 'react'

export const Error = ({ children }: PropsWithChildren) => {
  return (
    <div className="mt-xxs max-w-[450px] font-medium text-red-500">
      {children}
    </div>
  )
}
